import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { RequestGroup, ServiceRequest } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface UploadOrderRequisitionParams {
  entireOrder: boolean;
  file: File;
}

interface UploadOrderRequisitionResponse {
  requestGroup: RequestGroup;
  serviceRequests: ServiceRequest[];
}

export const useUploadOrderRequisition = ({
  patientId,
  requestGroupId,
  serviceRequestId,
}: {
  patientId: string;
  requestGroupId: string;
  serviceRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    UploadOrderRequisitionResponse,
    UploadOrderRequisitionParams
  >({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.MedicalRecords.Labs.UPLOAD_ORDER_REQUISITION(
          patientId,
          requestGroupId,
          serviceRequestId,
        ),
      mutationFn: ({ entireOrder, file }: UploadOrderRequisitionParams) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("entireOrder", entireOrder.toString());
        formData.append("requestGroupId", requestGroupId);
        formData.append("serviceRequestId", serviceRequestId);
        return axiosInstance.post(
          "/labs/order/upload-order-requisition",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
        });
      },
    },
  });
};
